import React from "react";
import { SVGAsset } from "res/";
import "./styles.css";
/**
 * @function SuccessNotificationView 
 * @param {OBJECT} props - Default React.Components props OBJECT
 * @param {BOOLEAN} showClose - Optional property to control if the close button is visible or not
 * @returns {React.Component}
 * @example
 * <LeftColumnContainer>
 *  <SuccessNotificationView>[message]</SuccessNotificationView>
 * </LeftColumnContainer>
*/
export default function SuccessNotificationView(props) {
  const message = props.message ?? "[message]";
  const showClose = props.showClose ?? true;

  return (
    <div className="flex-container flex-horizontal align-top alert-message success-alert">

      {/* left alert icon */}
      <div className="set-width alert-icon-container">
        <SVGAsset id="CheckmarkIcon" />
      </div>

      {/* alert text */}
      <div className="flex-width alert-text">
        <p data-point="Success_Notification_Message">{message}</p>
      </div>

      {/* right alert icon - close x */}
      { showClose && <div className="set-width alert-icon-container clickable">
        <SVGAsset id="XIcon" />
      </div> }
    </div>
  );
}